import { SmsHealthHistoryCell } from "@/components/CellRenderer";
import { Table } from "@/components/Table";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useGetShopifyHealthCheckHistoryTable } from "@/requests/hooks/collect";
import { createColumnHelper } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

const ShopifyHealthHistory = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const columnHelper = createColumnHelper<IShopifyHealthHistory>();

  const columns = [
    columnHelper.accessor("date", {
      header: t("sms.healthCheckHistory.shopify.table.columns.date"),
      size: 175,
    }),
    columnHelper.accessor("contentStatus", {
      header: t("sms.healthCheckHistory.shopify.table.columns.optInWording"),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
    columnHelper.accessor("privacyPolicy.status", {
      header: t(
        "sms.healthCheckHistory.shopify.table.columns.privacyPolicyWording",
      ),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
    columnHelper.accessor("privacyPolicy.url", {
      header: t(
        "sms.healthCheckHistory.shopify.table.columns.privacyPolicyAvailability",
      ),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
    columnHelper.accessor("termsOfService.status", {
      header: t(
        "sms.healthCheckHistory.shopify.table.columns.termsOfServiceWording",
      ),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
    columnHelper.accessor("termsOfService.url", {
      header: t(
        "sms.healthCheckHistory.shopify.table.columns.termsOfServiceAvailability",
      ),
      cell: info => <SmsHealthHistoryCell value={info.getValue()} />,
      meta: {
        align: "center",
      },
    }),
  ];

  return (
    <>
      <div className="mb-30 mt-50">
        <TypographyContainer>
          <HeaderTextBlock
            headingText={t("sms.healthCheckHistory.shopify.header.heading")}
            descriptionText={t(
              "sms.healthCheckHistory.shopify.header.description",
            )}
          />
        </TypographyContainer>
      </div>
      <Table
        columns={columns}
        queryKey={["collect", "sms", "healthCheckHistory", "shopify"]}
        queryHook={useGetShopifyHealthCheckHistoryTable}
        filters={{
          month: searchParams.get("month")!,
        }}
        isSearchEnabled={false}
      />
    </>
  );
};

export default ShopifyHealthHistory;
